import * as React from 'react';
import MuiPagination from '@mui/material/Pagination';
import PaginationItem, { PaginationItemProps } from '@mui/material/PaginationItem';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';

export type PaginationProps = {
  count: number;
  page: number;
  onChange: ((event: React.ChangeEvent<unknown>, page: number) => void) | undefined;
};

const StyledPaginationItem = styled(PaginationItem)(
  ({ theme }) => `
  color: ${theme.palette.neutral[80]};
  `,
);

const Pagination = ({ count, page, onChange }: PaginationProps) => {
  const theme = useTheme();
  return (
    <MuiPagination
      count={count || 0}
      page={page}
      onChange={onChange}
      sx={{
        '& .MuiPaginationItem-page': {
          backgroundColor: theme.palette.neutral[10],
          width: '40px',
          height: '40px',
          borderRadius: '80px',
          '&.Mui-selected': {
            background: theme.palette.blue[60],
            color: 'white',
            '&:hover': {
              background: theme.palette.blue[60],
              color: 'white',
            },
          },
          '&:hover': {
            background: theme.palette.blue[20],
            color: theme.palette.neutral[80],
          },
        },
      }}
      renderItem={(item: PaginationItemProps) => <StyledPaginationItem {...item} />}
    />
  ) as React.ReactNode;
};

export default Pagination;
export { Pagination };
